import containerFuild from '../../description/html-snippets/container-fuild.js';
import css from '../css-snippets/section-eskiin-hurrybox.js';

const img1 = 'https://cdn.skyfastimg.com/images/2026/10/01/image-6abe315c574bb1092af2ecce.webp?w=50&h=50&q=80';
const img2 = 'https://cdn.skyfastimg.com/images/2026/10/01/image-6abe3162cd4114188c1913d1.webp?w=50&h=50&q=80';
const img3 = 'https://cdn.skyfastimg.com/images/2026/10/01/image-6abe31697252298bb0ed47df.webp?w=50&h=50&q=80';
const img4 = 'https://cdn.skyfastimg.com/images/2026/10/01/image-6abe3170d53f329f3e252875.webp?w=50&h=50&q=80';

const defaultItems = [
  {
    preText: 'FREE',
    price: '$16',
    image: img1,
    title: '<p>Free & Fast</p><p>Shipping</p>',
  },
  {
    preText: 'FREE',
    price: '$16',
    image: img2,
    title: '<p>Free & Fast</p><p>Shipping</p>',
  },
  {
    preText: 'FREE',
    price: '$16',
    image: img3,
    title: '<p>Free & Fast</p><p>Shipping</p>',
  },
  {
    preText: 'FREE',
    price: '$16',
    image: img4,
    title: '<p>Free & Fast</p><p>Shipping</p>',
  },
];

const renderItem = item => `
  <div data-attribute="item" class="item-sm">
    <div class="wrap-main-item">
      <div data-attribute="tag-item" class="tag-item">
        <span data-attribute="pre-text">${item.preText}</span>
        <span data-attribute="price">${item.price}</span>
      </div>
      <div data-attribute="wrap-image" class="wrap-image">
        <img data-attribute="image-item" src="${item.image}" alt="" />
      </div>
    </div>
    <div data-attribute="title-item" class="title-item">${item.title}</div>
  </div>`;

const contentHtml = `
<div
  data-attribute="list-item"
  class="swrap-layout list-item"
  data-col-perview="4"
  color-brand="#005F2AFF"
  style="--col-perview: 4; --color-brand: #005f2aff"
>${defaultItems.map(renderItem).join('')}
</div>
`;

export default containerFuild(contentHtml, css, {
  topPadding: false,
  bottomPadding: false,
});
